import React from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import BuildIcon from '@mui/icons-material/Build';
import SendIcon from '@mui/icons-material/Send';
import VerifiedIcon from '@mui/icons-material/Verified';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

type Props = {
  fiscalYear: string;
  budgetVersionId: number | '';
  ppmName: string;
  status: string;
  notes: string;
  selectedPpm: any | null;
  loading?: boolean;
  onFiscalYearChange: (value: string) => void;
  onBudgetVersionIdChange: (value: number | '') => void;
  onPpmNameChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  onRefresh: () => void;
  onGenerate: () => void;
  onCalendarize: () => void;
  onSubmit: () => void;
  onApprove: () => void;
};

class PpmFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }} spacing={2} sx={{ mb: 2 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>PPM Controls</Typography>
            <Typography variant="caption" color="text.secondary">
              Generate and manage procurement plans from adopted budget versions.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={p.onRefresh} disabled={p.loading}>Refresh</Button>
            <Button variant="outlined" startIcon={<BuildIcon />} onClick={p.onGenerate} disabled={p.loading || !p.budgetVersionId}>Generate</Button>
            <Button variant="outlined" startIcon={<CalendarMonthIcon />} onClick={p.onCalendarize} disabled={p.loading || !p.selectedPpm}>Calendarize</Button>
            <Button variant="outlined" startIcon={<SendIcon />} onClick={p.onSubmit} disabled={p.loading || !p.selectedPpm}>Submit</Button>
            <Button variant="contained" startIcon={<VerifiedIcon />} onClick={p.onApprove} disabled={p.loading || !p.selectedPpm}>Approve</Button>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField size="small" label="Fiscal Year" value={p.fiscalYear} onChange={(e) => p.onFiscalYearChange(e.target.value)} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField size="small" type="number" label="Budget Version ID" value={p.budgetVersionId} onChange={(e) => p.onBudgetVersionIdChange(e.target.value === '' ? '' : Number(e.target.value))} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <TextField size="small" label="PPM Name" value={p.ppmName} onChange={(e) => p.onPpmNameChange(e.target.value)} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField size="small" label="Status" value={p.status} onChange={(e) => p.onStatusChange(e.target.value.toUpperCase())} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <TextField size="small" label="Notes" value={p.notes} onChange={(e) => p.onNotesChange(e.target.value)} fullWidth disabled={p.loading} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default PpmFilterBar;
